import { TooltipContent, TooltipRoot, TooltipTrigger, tokens } from "@blurb/codex-react";
import { IconV3 } from "@rpi/openapi-core";
import React from "react";

interface FieldInfoTooltipProps {
  /** Field name, used to build the trigger's accessible name. */
  label: string;
  content: string;
}

/** An info "i" icon beside a field label that reveals an explanatory tooltip on hover or focus. */
export const FieldInfoTooltip: React.FC<FieldInfoTooltipProps> = ({ label, content }) => (
  <TooltipRoot>
    <TooltipTrigger
      render={
        <div aria-label={`${label} information`} tabIndex={0}>
          <IconV3 icon="info" size={16} color={tokens.color.semantic.icon.subtle} />
        </div>
      }
    />
    <TooltipContent>{content}</TooltipContent>
  </TooltipRoot>
);
